import { render, staticRenderFns } from "./shortcutShippingOrderList.vue?vue&type=template&id=0a36951e&scoped=true&"
import script from "./shortcutShippingOrderList.vue?vue&type=script&lang=js&"
export * from "./shortcutShippingOrderList.vue?vue&type=script&lang=js&"
import style0 from "./shortcutShippingOrderList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./shortcutShippingOrderList.vue?vue&type=style&index=1&id=0a36951e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36951e",
  null
  
)

component.options.__file = "shortcutShippingOrderList.vue"
export default component.exports